export default __webpack_public_path__ + "static/media/TnB0719.c1db0904.jpg";